export const iconSizeMap = {
  s: '16px',
  m: '20px',
  l: '24px',
  xl: '32px',
  xxl: '48px'
};